import { Component, inject } from '@angular/core';
import {
  ClientsService,
  SelectedClient,
} from 'src/app/services/clients/clients.service';
import { RouterLink } from '@angular/router';
import { CurrencyPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-credit-display',
  templateUrl: './credit-display.component.html',
  styleUrls: ['./credit-display.component.scss'],
  imports: [RouterLink, CurrencyPipe, TranslateModule],
})
export class CreditDisplayComponent {
  private clientsService = inject(ClientsService);

  get client(): SelectedClient | null {
    return this.clientsService.selectedClientSubject.value;
  }
}
